<div class="flex flex-col w-full gap-1">

  <!-- Selected context badges -->
  @if (chatService.getContextLabel() || showContextEntityBadge() || viewerContext || session.selectedFiles.length > 0 || session.selectedRuns.length > 0 || session.LOI_Check || session.BIM_Check || session.HOAI_Check || session.QUALITY_Check) {
    <!--
      Die seitliche Einrueckung MUSS der des Eingabefeldes unten folgen: dort haengt sie am Layout
      (schwebend volle Breite, ganzseitig eingerueckt). Fest verdrahtetes mx-12 liess die Badges im
      schwebenden Chat eingerueckt ueber einem Feld voller Breite stehen.
      Kein zusaetzliches pb-*: den Abstand zum Feld gibt das gap-1 des Containers vor.
    -->
    <div [ngClass]="isCompactLayout() ? '' : 'ml-12 mr-12'"
         class="flex items-start justify-between gap-2">
      <div class="flex flex-row flex-wrap gap-2">
        @if (isCompactLayout() && chatService.getContextLabel()) {
          <bic-badge type="info">
            <div class="flex flex-row items-center gap-1.5">
              <fa-icon [icon]="getContextIcon()" class="text-xs"></fa-icon>
              <span>{{ chatService.getContextLabel() }}</span>
            </div>
          </bic-badge>
        }
        <!--
          Das konkrete Objekt, auf dem der Nutzer steht - der myCheck, der Prueflauf, die Aufgabe.
          Ohne dieses Badge sagt der Chat nur, in welchem MODUL man ist; gerade im Edit-Modus ist
          aber entscheidend, WELCHEN myCheck er gerade bearbeitet.

          Wie beim Modell darunter bewusst OHNE Entfernen-Kreuz: es ist kein ausgewaehlter Kontext,
          sondern der Ort, an dem der Nutzer steht. Erscheint erst, wenn der Name aufgeloest ist -
          eine rohe Kennung waere hier keine Hilfe.
        -->
        @if (showContextEntityBadge()) {
          <bic-badge type="info">
            <div class="flex flex-row items-center gap-1.5">
              <fa-icon [icon]="getContextIcon()" class="text-xs"></fa-icon>
              <span>{{ chatService.contextEntityLabel }}</span>
            </div>
          </bic-badge>
        }
        <!-- Das offene Modell: bewusst OHNE Entfernen-Kreuz. Es ist kein Kontext, den der Nutzer
             hier ausgewaehlt hat, sondern der Zustand des Viewers, in dem er gerade steht. -->
        @if (viewerContext) {
          <bic-badge type="info">
            <div class="flex flex-row items-center gap-1.5">
              <fa-icon [icon]="faIfc" class="text-xs"></fa-icon>
              <span>{{ viewerContext.fileName || 'Modell' }}{{ viewerModelSuffix }}</span>
            </div>
          </bic-badge>
        }
        @for (run of session.selectedRuns; track run.checkResultId ?? run.instanceId; let i = $index) {
          <bic-badge (click)="removeSelectedItem({type: 'RUNS'}, i)" class="cursor-pointer" type="info">
            <div class="flex flex-row items-center gap-1.5">
              <fa-icon [icon]="faMemoCircleCheck" class="text-xs"></fa-icon>
              <span>{{ run.name }}</span>
              <fa-icon [icon]="faXmark" class="text-xs"></fa-icon>
            </div>
          </bic-badge>
        }
        @if (session.LOI_Check) {
          <bic-badge (click)="removeSelectedItem({type: 'LOI'}, 0)" (mouseenter)="loicheckChipHovering = true"
                     (mouseleave)="loicheckChipHovering = false"
                     class="cursor-pointer"
                     type="info">
            <div class="flex flex-row items-center gap-1.5">
              <fa-icon [icon]="faMemoCircleCheck" class="text-xs"></fa-icon>
              <span>LOI-Check {{ session.LOI_Check.checkDate | date:'dd.MM.yyyy' }}</span>
              <fa-icon [icon]="faXmark" class="text-xs"></fa-icon>
            </div>
          </bic-badge>
        }
        @if (session.BIM_Check) {
          <bic-badge (click)="removeSelectedItem({type: 'BIM'}, 0)" (mouseenter)="bimcheckChipHovering = true"
                     (mouseleave)="bimcheckChipHovering = false"
                     class="cursor-pointer"
                     type="info">
            <div class="flex flex-row items-center gap-1.5">
              <fa-icon [icon]="faMemoCircleCheck" class="text-xs"></fa-icon>
              <span>LOIplus-Check {{ session.BIM_Check.checkDate | date:'dd.MM.yyyy' }}</span>
              <fa-icon [icon]="faXmark" class="text-xs"></fa-icon>
            </div>
          </bic-badge>
        }
        @if (session.HOAI_Check) {
          <bic-badge (click)="removeSelectedItem({type: 'HOAI'}, 0)" (mouseenter)="hoaiChipHovering = true"
                     (mouseleave)="hoaiChipHovering = false"
                     class="cursor-pointer"
                     type="info">
            <div class="flex flex-row items-center gap-1.5">
              <fa-icon [icon]="faMemoCircleCheck" class="text-xs"></fa-icon>
              <span>HOAI-Check {{ session.HOAI_Check.checkDate | date:'dd.MM.yyyy' }}</span>
              <fa-icon [icon]="faXmark" class="text-xs"></fa-icon>
            </div>
          </bic-badge>
        }
        @if (session.QUALITY_Check) {
          <bic-badge (click)="removeSelectedItem({type: 'QUALITY'}, 0)" (mouseenter)="qualityChipHovering = true"
                     (mouseleave)="qualityChipHovering = false"
                     class="cursor-pointer"
                     type="info">
            <div class="flex flex-row items-center gap-1.5">
              <fa-icon [icon]="faMemoCircleCheck" class="text-xs"></fa-icon>
              <span>All-Right-Check {{ session.QUALITY_Check.checkDate | date:'dd.MM.yyyy' }}</span>
              <fa-icon [icon]="faXmark" class="text-xs"></fa-icon>
            </div>
          </bic-badge>
        }
      </div>
      @if (session.selectedFiles.length > 0) {
        <div class="flex flex-row flex-wrap justify-end gap-2 ml-auto">
          @for (file of session.selectedFiles; track file.id; let i = $index) {
            <bic-badge (click)="removeSelectedItem({type: 'FILES'}, i)" class="cursor-pointer"
                       type="info">
              <div class="flex flex-row items-center gap-1.5">
                <fa-icon [icon]="faFilePdf" class="text-xs"></fa-icon>
                <span>{{ file.fileName }}</span>
                <fa-icon [icon]="faXmark" class="text-xs"></fa-icon>
              </div>
            </bic-badge>
          }
        </div>
      }
    </div>
  }

  @if (activeOptionUiBlocks.length > 0) {
    <div [ngClass]="isCompactLayout() ? 'w-full mb-2' : 'mb-2 ml-12 mr-12'" class="flex flex-col gap-2">
      @for (entry of activeOptionUiBlocks; track trackByActiveOptionUiBlock($index, entry)) {
        <app-ui-block-panel
          [surface]="surface"
          [blockIndex]="entry.blockIndex"
          [compact]="true"
          [messageId]="entry.messageId"
          [uiBlock]="entry.uiBlock"></app-ui-block-panel>
      }
    </div>
  }

  @if (chatService.chatQuota.exceeded) {
    <div [ngClass]="isCompactLayout() ? 'w-full mb-2' : 'mb-2 ml-12 mr-12'"
         class="flex flex-row items-start gap-2 rounded-md border border-yellow bg-yellow-50 px-3 py-2 text-sm text-secondary"
         role="alert">
      <fa-icon [icon]="faTriangleExclamation" class="mt-0.5 text-yellow-700"></fa-icon>
      <span>{{ sendDisabledTooltip }}</span>
    </div>
  }

  <!-- Text input area -->
  <bic-input (input)="adjustTextareaHeight()"
             (keydown.enter)="!session.isBotThinking && session.question.trim() && !chatBICUnavailable && askQuestion(session.question); $event.preventDefault(); $event.stopPropagation()"
             [(ngModel)]="session.question"
             [placeholder]="messagePlaceholder()"
             [showX]="false"
             [ngClass]="isCompactLayout() ? 'w-full chat-bic-input' : 'ml-12 mr-12 chat-bic-input'">

    <div class="flex flex-row gap-2" iconEnd>
      <button (click)="onPlusButtonClick()" [disabled]="isLoadingData" class="group">
        <fa-icon [animation]="isLoadingData ? 'spin-pulse' : undefined"
                 [icon]="isLoadingData ? faSpinnerThird : faPlus"
                 class="text-lg text-gray-300 group-hover:text-gray"></fa-icon>
      </button>
      <!-- Der Tooltip sitzt am Wrapper, nicht am Button: ein disabled-Button feuert keine
           Hover-Events, der Hinweis waere sonst genau im Sperrfall unsichtbar. -->
      @if (chatService.canStop(surface)) {
        <!-- Stopp statt Senden, solange eine Antwort läuft: der Teiltext bleibt stehen. -->
        <span [tooltip]="'Antwort stoppen'" [tooltipDirection]="'top'">
          <button (click)="stopAnswer(); $event.stopPropagation()" class="group" type="button">
            <fa-icon [icon]="faStop" class="text-lg text-gray-500 group-hover:text-gray"></fa-icon>
          </button>
        </span>
      } @else {
      <span [tooltip]="sendTooltip" [tooltipDirection]="'top'">
      <button
        (click)="askQuestion(session.question);$event.stopPropagation()"
        [disabled]="session.isBotThinking || !session.question.trim() || chatBICUnavailable"
        class="group">
        <fa-icon
          [icon]="faPaperPlaneTop"
          [ngClass]="{
              'text-gray-500 group-hover:text-gray': !session.isBotThinking && session.question.trim() && !chatBICUnavailable,
              'text-gray-300 cursor-not-allowed': session.isBotThinking || !session.question.trim() || chatBICUnavailable,
              'text-lg': true
            }">
        </fa-icon>
      </button>
      </span>
      }
    </div>

  </bic-input>
  <div [ngClass]="isCompactLayout() ? '' : 'ml-14'" class="text-xs text-gray-500">chatBIC kann Fehler machen.
    Überprüfe wichtige Informationen.
  </div>


</div>

<!-- Folder / Module Popup -->
@if (showFolderPopup) {
  <bic-popup
    (close)="closeFolderPopup()"
    [title]="'Kontext für chatBIC auswählen'"
    customClass="w-[560px] max-w-full mx-4">
    <div bicPopupContent class="flex flex-col gap-4">
      <div class="flex flex-row w-full gap-2.5 items-center">
        <fa-icon [icon]="faHouse" class="text-sm text-gray-400"></fa-icon>
        @if (selectedModule) {
          <fa-icon [icon]="faChevronRight" class="text-gray-400"></fa-icon>
          <span class="font-medium text-gray-900 truncate">{{ selectedModule.label }}</span>
        }
      </div>
      @if (!selectedModule) {
        <div class="flex flex-col rounded-lg border border-gray-200 max-h-[320px] overflow-y-auto">
          @for (module of modules; track module) {
            <div
              (click)="navigateIntoModule(module)"
              class="flex flex-row items-center justify-between cursor-pointer hover:bg-gray-50 border-b border-gray-200 last:border-b-0">
              <div class="flex items-center min-w-0">
                <fa-icon [icon]="module.icon" class="text-green-500 text-base p-2 shrink-0"></fa-icon>
                <span class="font-medium py-2 truncate">{{ module.label }}</span>
              </div>
              <fa-icon [icon]="faChevronRight" class="text-gray-400 mr-3 shrink-0"></fa-icon>
            </div>
          }
        </div>
      }
      @if (selectedModule && selectedModule.key !== 'FILES') {
        <div class="flex flex-col rounded-lg border border-gray-200">
          <div (click)="selectedModule = null"
               class="flex items-center text-sm text-gray-500 cursor-pointer hover:text-gray-700 p-2 border-b border-gray-200">
            <fa-icon [icon]="faChevronLeft" class="mr-2"></fa-icon>
            Zurück
          </div>
          <div
            class="max-h-[300px] overflow-y-auto scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-transparent">
            @for (item of getModuleItems(); track item) {
              <div
                (click)="onModuleItemClick(item)"
                [ngClass]="{'bg-gray-100': isModuleItemSelected(item)}"
                class="flex flex-row items-center justify-between cursor-pointer hover:bg-gray-50 border-b border-gray-200 last:border-b-0">
                <div class="flex items-center min-w-0">
                  <fa-icon [icon]="selectedModule.innerIcon" class="text-green-500 text-base p-2 shrink-0"></fa-icon>
                  <span class="font-medium py-2 truncate max-w-[280px]">
                    @switch (selectedModule.key) {
                      @case ('BIM') {
                        <span>{{ item.checkDate | date:'dd.MM.yyyy HH:mm' || 'Kein Datum' }}</span>
                      }
                      @case ('LOI') {
                        <span>{{ item.checkDate | date:'dd.MM.yyyy HH:mm' || 'Kein Datum' }}</span>
                      }
                      @case ('HOAI') {
                        <span>{{ item.checkDate | date:'dd.MM.yyyy HH:mm' || 'Kein Datum' }}</span>
                      }
                      @case ('All-Right') {
                        <span>{{ item.checkDate | date:'dd.MM.yyyy HH:mm' || 'Kein Datum' }}</span>
                      }
                      @case ('RUNS') {
                        <span>{{ runLabel(item) }}</span>
                        <span class="text-gray-400 font-normal ml-2">{{ item.checkDate | date:'dd.MM.yyyy HH:mm' }}</span>
                      }
                      @default {
                        <span>{{ item.fileName || item.name || item.checkId || 'Unbenannt' }}</span>
                      }
                    }
                  </span>
                </div>
              </div>
            }
            @if (getModuleItems().length === 0) {
              <div class="text-gray-400 text-sm text-center py-6">Keine Elemente gefunden</div>
            }
          </div>
        </div>
      }
    </div>
    <div bicPopupButtonGroup class="flex flex-row w-full justify-end gap-4">
      <bic-button (onClick)="closeFolderPopup()" buttonType="white">Abbrechen</bic-button>
      @if (selectedModule && selectedModule.key !== 'FILES') {
        <bic-button (onClick)="selectModuleItem(selectedModuleItem)" [disabled]="!selectedModuleItem"
                    buttonType="primary">Auswählen
        </bic-button>
      }
    </div>
  </bic-popup>
}

<!-- Dateiauswahl: im Quickstart direkt über „+", im klassischen Chat über das Modul „Dateien" -->
@if (showFilePicker) {
  <app-context-file-picker
    [title]="'Dateien als Kontext für chatBIC auswählen'"
    [excludeIds]="selectedFileIds"
    (selected)="onContextFilesPicked($event)"
    (closed)="onFilePickerClosed()">
  </app-context-file-picker>
}
